// Datos de facturación de empresa en el carrito: se guardan como atributos del carrito (pasan al pedido y a la factura).
(() => {
  const NIF = /^([A-HJ-NP-SUVW]\d{7}[0-9A-J]|\d{8}[A-Z]|[XYZ]\d{7}[A-Z])$/; // CIF, DNI/NIF o NIE
  const limpiar = (v) => String(v || '').toUpperCase().replace(/[\s.\-]/g, '');
  let t = null;
  const guardar = (box) => {
    clearTimeout(t);
    t = setTimeout(() => {
      const on = box.querySelector('[data-pm-fact-toggle]').checked;
      const attributes = { 'Factura a empresa': on ? 'Sí' : 'No' };
      box.querySelectorAll('.pm-fact__campos input').forEach((i) => { attributes[i.name.slice(11, -1)] = on ? (i.matches('[data-pm-fact-nif]') ? limpiar(i.value) : i.value.trim()) : ''; });
      fetch((window.routes?.cart_update_url || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) }).catch(() => {});
    }, 400);
  };
  const valido = (box) => {
    if (!box.querySelector('[data-pm-fact-toggle]').checked) return true;
    let ok = true;
    box.querySelectorAll('[data-pm-fact-req]').forEach((i) => {
      const v = i.matches('[data-pm-fact-nif]') ? limpiar(i.value) : i.value.trim();
      const bien = i.matches('[data-pm-fact-nif]') ? NIF.test(v) : v.length > 1;
      i.setAttribute('aria-invalid', bien ? 'false' : 'true');
      if (!bien) ok = false;
    });
    box.querySelector('[data-pm-fact-error]').hidden = ok;
    return ok;
  };
  // Si hay dos bloques (carrito lateral y página del carrito), se mantienen iguales.
  const espejo = (box, el) => document.querySelectorAll('[data-pm-fact]').forEach((otro) => {
    if (otro === box) return;
    const gemelo = otro.querySelector(`input[name="${el.name}"]:not([type=hidden])`);
    if (!gemelo) return;
    if (el.type === 'checkbox') { gemelo.checked = el.checked; otro.querySelector('.pm-fact__campos').hidden = !el.checked; otro.querySelector('[data-pm-fact-off]').disabled = el.checked; }
    else gemelo.value = el.value;
  });
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-pm-fact]');
    if (!box) return;
    espejo(box, e.target);
    if (e.target.matches('[data-pm-fact-toggle]')) {
      box.querySelector('.pm-fact__campos').hidden = !e.target.checked;
      box.querySelector('[data-pm-fact-off]').disabled = e.target.checked;
    }
    guardar(box);
  });
  document.addEventListener('input', (e) => { const box = e.target.closest('[data-pm-fact]'); if (box) { espejo(box, e.target); guardar(box); } });
  // Antes de ir al pago: si pide factura de empresa, razón social y CIF/NIF obligatorios.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    const box = (btn.form || document).querySelector('[data-pm-fact]') || document.querySelector('[data-pm-fact]');
    const form = btn.getAttribute('form');
    const propia = form && document.querySelector(`[data-pm-fact] [form="${form}"]`)?.closest('[data-pm-fact]');
    const b = propia || box;
    if (b && !valido(b)) { e.preventDefault(); e.stopPropagation(); b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, true);
})();
